import React from 'react'
import { Div, DivTitle, Title, ManSvg, WomanSvg, DivImage, CarouselTestimonios} from './styles';

export const SliderTestimonios = () => {

    const images = [<ManSvg />, <WomanSvg />, <ManSvg />, <WomanSvg />]

    const settings = {
        customPaging: function(i) {
            return (
              <DivImage>
                {images[i]}
              </DivImage>
            );
          },
        dots: true,
        fade: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };

      return (
        <DivTitle>
          <Title>TESTIMONIOS</Title>
          <CarouselTestimonios {...settings}>
            <Div>
              <div>Muy buen producto. Matias</div>
            </Div>
            <Div>
                <div>Muy efectivo. Carlos</div>
            </Div>
            <Div>
                <div>Lo recomiendo 100%. Catalina</div>
            </Div>
            <Div>
                <div>Eliminó mis imperfecciones de la cara. Cristian</div>
            </Div>
          </CarouselTestimonios>
        </DivTitle>
      );
}